export default "__VITE_ASSET__ayOT7w1n__"